import { Component, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { AppSnackBar } from '../../app-services/snackbar/snackbar.app';
import { MaterialDesignConfig } from '../../app.config.material';

@Component({
    selector: 'app-snack-bar-notification-request',
    imports: [
        ...MaterialDesignConfig
    ],
    templateUrl: './snack-bar-notification-request.component.html',
    styleUrl: './snack-bar-notification-request.component.scss'
})
export class SnackBarNotificationRequestComponent {

  constructor(
    private readonly appSnackBar: AppSnackBar,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Inject(MAT_SNACK_BAR_DATA) public data: any
  ) { }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  dismiss(response: any): void {
    this.appSnackBar.dismissSnackBar(response);
  }
}
